import { CLMButtonPrimary, CLMButtonSecondary } from "../v3/Buttons";

const RequestDemo = ({ title, btnText, bgColor, btnBgColor, btnTextColor }) => {
  return (
    <section
      className={`max-w-screen-xl xl:mx-auto mx-4 md:mx-10 py-8 xl:px-8`}
    >
      <div
        className={` flex flex-col items-center justify-center gap-4 md:gap-8 rounded-3xl ${bgColor} p-4 py-8 md:p-12 `}
      >
        <p className="text-white text-2xl md:text-5xl font-semibold text-center w-full md:w-[85%] ">
          {title}
        </p>
        {/* if btnBgColor is provided then use it else use default */}
        {/* <button
          className={` text-white px-12 py-2 md:py-3 w-full md:w-auto text-base rounded-full ${btnBgColor} ${btnTextColor}`}
        >
          {btnText}
        </button> */}
        <CLMButtonPrimary buttonText={btnText} buttonUrl="/clm/request-demo" />
      </div>
    </section>
  );
};

export default RequestDemo;
